module.exports = __webpack_public_path__ + "static/media/payment_new.6d745460.svg";